import { fleetRoute } from '@/modules/fleet/route';
import { createRoute, redirect } from '@tanstack/react-router';

export const fleetIndexRoute = createRoute({
  getParentRoute: () => fleetRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({
      to: '/fleet/map',
    });
  },
});
